import { DynamicEmsData, EmsBatteryMode } from '../../types'

/**
 * Function returns an offset number if the data overflows the right y axis domain
 * @param dynamicEmsData Array of DynamicEmsData
 * @param mode EmsBatteryMode
 * @param maxValue highest powerPrice for mode parsed to the function
 * @param minValue lowest powerprice shown in the chart (eg. most of the time domain[0])
 * @param isLastModeDoubled is a boolean to determine if the last mode of dynamicEmsData is presented more than once
 * @returns y2 stop percentage for the gradient
 */
export const getGradientOffset = (
  dynamicEmsData: DynamicEmsData[],
  mode: EmsBatteryMode,
  maxValue: number,
  minValue: number,
  isLastModeDoubled: boolean
): number => {
  if (dynamicEmsData.length === 0) return 1
  if (mode === dynamicEmsData.at(-1)?.emsBatteryMode && !isLastModeDoubled) {
    return 1
  }
  return (maxValue - minValue) / maxValue
}
